// extracted by mini-css-extract-plugin
module.exports = {"tour":"TourPreview_tour__2Vj77","isLg":"TourPreview_isLg__3KsHe","cover":"TourPreview_cover__2ihMc","textWrapper":"TourPreview_textWrapper__3PM5J","name":"TourPreview_name__1BcHU"};